import { render, staticRenderFns } from "./reson.vue?vue&type=template&id=4679ae9c&scoped=true&"
import script from "./reson.vue?vue&type=script&lang=js&"
export * from "./reson.vue?vue&type=script&lang=js&"
import style0 from "./reson.vue?vue&type=style&index=0&id=4679ae9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679ae9c",
  null
  
)

export default component.exports